import { ContentLibrary } from '@deltek/specification-client/core/Models/product'

const defaultFormatText = ({ value }: { value: any }) => {
    if (value && value !== 'null') {
        return value
    } else {
        return ''
    }
}

const tableFormattedText: Record<string, (prop: any) => any> = {
    displayNameWithFirmName: ({ value }: { value: string }) => {
        if (value) {
            const actualString = value
                ?.split('%|%')
                ?.map((val) => val?.replaceAll("'", ''))
            return actualString?.[0] !== 'null'
                ? `${actualString?.[0]} (${actualString?.[1]})`
                : `${actualString?.[1]}`
        } else {
            return ''
        }
    },
    categories: ({ value }: { value: string[] }) => {
        if (value) {
            return value?.join(', ')
        } else {
            return ''
        }
    },
    hasManufacturerOptions: ({ value }: { value: any }) => {
        if (value === true || value === false) {
            return value ? 'True' : 'False'
        } else {
            return ''
        }
    },
    isActive: ({ value }: { value: any }) => {
        if (value === true || value === false) {
            return value ? 'Active' : 'Inactive'
        } else {
            return ''
        }
    },
    canAutoGenerateProductSpecification: ({ value }: { value: any }) => {
        if (value === true || value === false) {
            return value
                ? 'Can auto-generate product specification'
                : 'Cannot auto-generate product specification'
        } else {
            return ''
        }
    },
    firmLogoUrl: defaultFormatText,
    partnershipLinksSwatchbox: defaultFormatText,
    partnershipLinksSM: defaultFormatText,
    partnershipLinksULE: defaultFormatText,
    contentLibrary: ({ value }: { value: any }) => {
        return ContentLibrary[value as keyof typeof ContentLibrary]
    },
}

export default tableFormattedText
